export default "/images/vendor/flag-icon-css/flags/1x1/rs.svg?9f00a7d8eafa6f593713c1c4b255d84f";